import { useRef } from 'react'

import { NavigationOptions } from 'swiper/types'
import { SwiperProps } from 'swiper/react'
import classNames from '../classNames'
import { needsNavigation as needsNavigationFn } from './utils'

export interface UseNavigationType {
  prevElRef: React.Ref<HTMLDivElement>
  nextElRef: React.Ref<HTMLDivElement>
  needsNavigation: boolean
  navigationProps?: boolean | NavigationOptions
}

const defaultNavigationConfig = {
  hideOnClick: false,
  disabledClass: classNames.navigationButtonDisabled,
  hiddenClass: classNames.navigationButtonHidden,
  lockClass: classNames.navigationButtonLock,
}

export const useNavigation = (props: SwiperProps): UseNavigationType => {
  const nextElRef = useRef(null)
  const prevElRef = useRef(null)

  const needsNavigation = needsNavigationFn(props)
  const navigationProps =
    props.navigation && needsNavigation
      ? {
          ...defaultNavigationConfig,
          ...(typeof props.navigation === 'object' ? props.navigation : {}),
          nextEl: nextElRef.current,
          prevEl: prevElRef.current,
        }
      : props.navigation

  return {
    prevElRef,
    nextElRef,
    needsNavigation,
    navigationProps: navigationProps,
  }
}
